import React from "react";
import CryptoJS from "crypto-js";
const SECRET_KEY = process.env.REACT_APP_SECERET_KEY_AES;

const Decrypt = (encryptedText) => {
  try {
    // Split the IV and encrypted data
    const [iv, encryptedData] = encryptedText.split(":");

    if (!iv || !encryptedData) {
      throw new Error("Invalid encrypted text format");
    }

    // Parse the IV and encrypted data to WordArray (binary data)
    const ivBytes = CryptoJS.enc.Hex.parse(iv);
    const encryptedBytes = CryptoJS.enc.Hex.parse(encryptedData);

    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes },
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Convert the decrypted data back to a string
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting data:", error.message);
    return null;
  }
};

export default Decrypt;
